import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {ArrowDownSquareFill} from "react-bootstrap-icons";
import {Util} from "../../components/Util";
import {SysButton} from "../../components/Elements/SysButton";
import {RightAside} from "../../components/Aside/RightAside";
import {OrderScheduleCreate} from "./OrderScheduleCreate";

export class OrderScheduleList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return `/order-schedule`;
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(),
            getDateStatus = this.isDateActive;

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    {this.user.hasRight('order-schedule/create') && this.state.item &&
                        <OrderScheduleCreate services={this.state.item.services}/>}

                    <form className="x-form" method="GET" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'status',
                                        basic: 'show-all',
                                        items: ['active', 'expired', 'future'],
                                        defaultValue: params?.status
                                    }}/>
                                </div>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'os.id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/order-schedule/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                {this.user.hasRight('order-schedule/create') && this.state.item && <>
                                    <SysButton onClick={RightAside.open} type={'PlusCircleFill'}
                                               data-open={'#create-details'}
                                               text={this.dictionary.get['create-order-schedule']} style={{
                                        display: 'block',
                                        float: 'left',
                                        margin: '10px 4px 0 4px',
                                        padding: '7px 12px 7px 12px'
                                    }}/>
                                </>}
                                &nbsp;
                                &nbsp;
                                <h6 style={{width: '100%'}}>
                                    {this.dictionary.get['order-schedule']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="os.id">
                                    #ID<i className="bi bi-sort-down"></i>
                                </th>
                                <th>{this.dictionary.get['sku']}</th>
                                <th>{this.dictionary.get['name']}</th>
                                <th>{this.dictionary.get['status']}</th>
                                <th className="sortable" data-sortkey="os.schedule_start">
                                    {this.dictionary.get['schedule_start']}
                                </th>
                                <th className="sortable" data-sortkey="os.schedule_end">
                                    {this.dictionary.get['schedule_end']}
                                </th>
                                <th className="sortable" data-sortkey="os.created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                                <th className="sortable" data-sortkey="os.updated_at">
                                    {this.dictionary.get['updated_at']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let status = getDateStatus(elem.schedule_start, elem.schedule_end);

                                return (
                                    <tr key={elem.id + '-sku:' + elem.sku} data-id={elem.id}>
                                        <td>{Util.link(elem.id, '/order-schedule/details/' + elem.id)}</td>
                                        {Util.searchCell(elem.sku, 'sku')}
                                        <td>{elem.name}</td>
                                        <td>{Util.status(status, {style: {fontSize: '11px', fontWeight: 600}})}</td>
                                        <td><DateTime value={elem.schedule_start} inline={true}/></td>
                                        <td><DateTime value={elem.schedule_end} inline={true}/></td>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                        <td><DateTime value={elem.updated_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={7}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }

    isDateActive(startStr: string, endStr: string): string {
        const now = new Date();
        const startDate = new Date(startStr);
        const endDate = new Date(endStr);

        if (now < startDate) {
            return 'future';
        }
        if (endDate < now) {
            return 'expired';
        }
        return 'active';
    }
}
